<template>
  <div id="add-education-details">
    <!-- Premium Header -->
    <div class="header-section">
      <div class="header-gradient">
        <v-row align="center" justify="space-between" class="pa-6">
          <v-col cols="12" md="8">
            <div class="d-flex align-center">
              <div class="header-icon-box">
                <v-icon size="40" color="white">mdi-school</v-icon>
              </div>
              <div class="ml-4">
                <h2 class="header-title white--text mb-1">{{ pageTitle }}</h2>
                <p class="header-subtitle white--text mb-0">
                  Add and manage your educational qualifications
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="text-right">
            <v-btn icon dark large @click="closePrompt" class="close-btn">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-card class="form-card">
      <v-form ref="form1" v-model="valid1" lazy-validation v-on:submit.prevent="submitForm">
        <v-card-text>
          <!-- Required Fields Note -->
          <v-card class="required-note-card mb-6" elevation="0">
            <v-card-text class="pa-4">
              <div class="d-flex align-center gap-3">
                <v-icon class="required-icon">mdi-alert-circle</v-icon>
                <div>
                  <span class="required-label">* indicates required field</span>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <!-- Education Section -->
          <v-card class="section-card mb-6" elevation="0">
            <v-card-title class="section-title">
              <v-icon class="mr-2">mdi-book-open-page-variant</v-icon>
              Education Information
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-6">
              <v-row wrap>
                <v-col cols="12" sm="6" md="3">
                  <label class="field-label">
                    <span class="text-danger">*</span> Year
                  </label>
                  <v-autocomplete :reduce="(option) => option.value" :loading="YearIdOptionsLoading"
                    :items="YearIdOptions" :rules="YearIdRules" v-model="YearId" required outlined dense
                    prepend-icon="mdi-calendar" placeholder="Select Year" class="field-input"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <label class="field-label">
                    <span class="text-danger">*</span> Education Level
                  </label>
                  <v-autocomplete :reduce="(option) => option.value" :loading="QualificationIdOptionsLoading"
                    :items="QualificationIdOptions" :rules="QualificationIdRules" v-model="QualificationId" required
                    outlined dense prepend-icon="mdi-layers" placeholder="Select Level"
                    class="field-input"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <label class="field-label">
                    <span class="text-danger">*</span> Degree
                  </label>
                  <v-autocomplete :reduce="(option) => option.value" :loading="DegreeIdOptionsLoading"
                    :items="DegreeIdOptions" :rules="DegreeIdRules" v-model="DegreeId" required outlined dense
                    prepend-icon="mdi-certificate" placeholder="Select Degree" class="field-input"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <label class="field-label">
                    <span class="text-danger">*</span> Specialization
                  </label>
                  <v-autocomplete :reduce="(option) => option.value" :loading="SpecilizationIdOptionsLoading"
                    :items="SpecilizationIdOptions" :rules="SpecilizationIdRules" v-model="SpecilizationId" required
                    outlined dense prepend-icon="mdi-lightbulb" placeholder="Select Specialization"
                    class="field-input"></v-autocomplete>
                </v-col>
              </v-row>

              <v-row wrap>
                <v-col cols="12" sm="12" md="12">
                  <label class="field-label">
                    <v-icon small class="mr-1">mdi-university</v-icon>
                    Institution
                    <small class="text-muted">(optional)</small>
                  </label>
                  <v-text-field v-model="Institution" :rules="InstitutionRules"
                    placeholder="e.g., Harvard University, MIT, Oxford" hint="Enter your institution name"
                    prepend-icon="mdi-domain" outlined dense class="field-input"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Action Buttons -->
          <v-row wrap class="button-section">
            <v-col align="center" cols="12" md="12">
              <v-btn @click="closePrompt" elevation="0" color="#a52a2a"
                class="action-btn close-btn white--text font-weight-bold">
                <v-icon left>mdi-close</v-icon>
                Close
              </v-btn>
              <v-btn :disabled="!valid1" @click.prevent="submitForm" :loading="SubmitFlag" elevation="0" color="success"
                class="action-btn save-btn white--text font-weight-bold ml-3">
                <v-icon left>mdi-check-circle</v-icon>
                Save Education
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    pageDescription: {
      type: String
    }
  },
  data() {
    return {
      pageTitle: "Add Education Details",
      pageDescription: "Add Education Details",

      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,

      UploadFlag: false,

      YearIdRules: [v => !!v || "Year is required"],
      YearId: "",
      YearIdOptions: [],
      YearIdOptionsLoading: false,

      QualificationIdRules: [v => !!v || "Qualification is required"],
      QualificationId: "",
      QualificationIdOptions: [],
      QualificationIdOptionsLoading: false,

      DegreeIdRules: [v => !!v || "Degree is required"],
      DegreeId: "",
      DegreeIdOptions: [],
      DegreeIdOptionsLoading: false,

      SpecilizationIdRules: [v => !!v || "Specilization is required"],
      SpecilizationId: "",
      SpecilizationIdOptions: [],
      SpecilizationIdOptionsLoading: false,

      Institution: "",
      InstitutionRules: []
    };
  },
  computed: {},
  watch: {
    YearIdOptions: function () {
      console.log("watch YearIdOptions");
      this.LoadingFlag = false;
      this.YearIdOptionsLoading = false;
    },
    QualificationIdOptions: function () {
      console.log("watch QualificationIdOptions");
      this.LoadingFlag = false;
      this.QualificationIdOptionsLoading = false;
    },
    DegreeIdOptions: function () {
      console.log("watch DegreeIdOptions");
      this.LoadingFlag = false;
      this.DegreeIdOptionsLoading = false;
    },
    SpecilizationIdOptions: function () {
      console.log("watch SpecilizationIdOptions");
      this.LoadingFlag = false;
      this.SpecilizationIdOptionsLoading = false;
    }
  },
  created() {
    // this.initialize()
  },
  methods: {
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      this.closePrompt();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt(EducationDetails = {}) {
      console.log("closePrompt called");
      this.$emit("hideAddRecordPrompt", EducationDetails);
    },
    refreshPageData() {
      console.log("refreshPageData called");

      this.YearIdOptionsLoading = true;
      this.getCategoryOptions("YearId", "YearIdOptions", {
        UserInterface: 1,
        CategoryMainId: 9,
        OrderBy: "category_sub_name desc"
      });

      this.QualificationIdOptionsLoading = true;
      this.getCategoryOptions("QualificationId", "QualificationIdOptions", {
        UserInterface: 1,
        CategoryMainId: 10
      });

      this.DegreeIdOptionsLoading = true;
      this.getCategoryOptions("DegreeId", "DegreeIdOptions", {
        UserInterface: 1,
        CategoryMainId: 11
      });

      this.SpecilizationIdOptionsLoading = true;
      this.getCategoryOptions("SpecilizationId", "SpecilizationIdOptions", {
        UserInterface: 1,
        CategoryMainId: 12
      });
    },
    getCategoryOptions(source, destination, condition) {
      console.log("getCategoryOptions called");
      console.log("source=" + source + ", destination=" + destination);
      var n1 = Object.keys(condition).length;
      console.log("n1=" + n1 + ", condition=" + JSON.stringify(condition));
      if (source != "" && destination != "" && n1 > 0) {
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/sub-category/options";
        var selectbox1_conditions_array = condition;
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      if (validate1) {
        var YearId = this.YearId;
        var SpecilizationId = this.SpecilizationId;
        var DegreeId = this.DegreeId;
        var QualificationId = this.QualificationId;
        console.log("YearIdOptions=" + JSON.stringify(this.YearIdOptions));
        console.log("YearId=" + YearId);

        var Year = this.YearIdOptions.find(data => {
          return data.value == YearId;
        });
        var YearTxt = Year.text;

        var Qualification = this.QualificationIdOptions.find(data => {
          return data.value == QualificationId;
        });
        var QualificationTxt = Qualification.text;

        var Degree = this.DegreeIdOptions.find(data => {
          return data.value == DegreeId;
        });
        var DegreeTxt = Degree.text;

        var Specilization = this.SpecilizationIdOptions.find(data => {
          return data.value == SpecilizationId;
        });
        var SpecilizationTxt = Specilization.text;

        var MemberId = this.$session.get("MemberId");

        console.log(
          "YearTxt=" +
          YearTxt +
          "; QualificationTxt=" +
          QualificationTxt +
          "; DegreeTxt=" +
          DegreeTxt +
          "; SpecilizationTxt=" +
          SpecilizationTxt +
          "; MemberId=" +
          MemberId
        );

        var EducationDetails = {
          UserInterface: 1,
          MemberId: MemberId,
          Year: YearId,
          Qualification: QualificationId,
          Degree: DegreeId,
          Specilization: SpecilizationId,
          YearTxt: YearTxt,
          QualificationTxt: QualificationTxt,
          DegreeTxt: DegreeTxt,
          SpecilizationTxt: SpecilizationTxt,
          Institution: this.Institution,
          InsertFlag: true
        };
        this.$emit("hideAddRecordPrompt", EducationDetails);
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields";
        }
        this.sweetAlert("error", message, false);
      }
    }
  },
  beforeMount() {
    this.refreshPageData();
  }
};
</script>
<style lang="scss" scoped>
// Color Palette
$navy: #3A67B1;
$aqua: #0097D7;
$gold: #EDBE38;
$seaform: #56BDA3;
$text-90-black: #414042;
$text-off-black: #0A0F29;
$text-white: #FFFFFF;
$danger: #e74c3c;
$success: #1db954;
$info: #2196F3;

$primary-color: $navy;
$secondary-color: $aqua;
$bg-light: #f8fafc;
$border-color: #e2e8f0;

// Animations
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-12px);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

#add-education-details {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px 0;
  min-height: 100vh;

  // ============================================
  // HEADER SECTION
  // ============================================
  .header-section {
    background: linear-gradient(135deg, $navy 0%, $aqua 50%, $navy 100%) !important;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.5), 0 0 40px rgba(0, 151, 215, 0.3);
    margin: 15px !important;

    &::before {
      content: '';
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
      animation: rotate 20s linear infinite;
    }

    .header-gradient {
      position: relative;
      z-index: 1;
    }
  }

  .header-icon-box {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    padding: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    animation: float 3s ease-in-out infinite;
  }

  .header-title {
    font-size: 28px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    animation: fadeInUp 0.8s ease-out;
  }

  .header-subtitle {
    font-size: 14px;
    opacity: 0.95;
    letter-spacing: 0.3px;
    animation: fadeInUp 1s ease-out;
  }

  .close-btn {
    background: rgba(255, 255, 255, 0.15) !important;
    backdrop-filter: blur(10px);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 2px solid rgba(255, 255, 255, 0.2);

    &:hover {
      background: rgba(255, 255, 255, 0.25) !important;
      transform: scale(1.1) rotate(90deg);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    }
  }

  .action-btn {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-weight: 700;

    &:not(.close-btn) {
      background: rgba(255, 255, 255, 0.15) !important;
      border: 2px solid rgba(255, 255, 255, 0.3) !important;
      backdrop-filter: blur(10px);
      color: white !important;

      &:hover {
        background: rgba(255, 255, 255, 0.25) !important;
        transform: scale(1.1);
      }
    }
  }

  // ============================================
  // FORM CARD
  // ============================================
  .form-card {
    border-radius: 18px !important;
    border: 2px solid rgba(58, 103, 177, 0.2);
    box-shadow: 0 12px 40px rgba(58, 103, 177, 0.15), 0 0 30px rgba(0, 151, 215, 0.08);
    animation: fadeInScale 0.6s ease-out;
    background: linear-gradient(to bottom, #ffffff 0%, #fafbff 50%, #f5f7ff 100%);
    position: relative;
    overflow: hidden;
    margin: 0 15px 20px 15px;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(circle at 100% 0%, rgba(0, 151, 215, 0.1) 0%, transparent 50%);
      pointer-events: none;
    }
  }

  // ============================================
  // REQUIRED NOTE CARD
  // ============================================
  .required-note-card {
    border-radius: 12px !important;
    background: linear-gradient(135deg, rgba(58, 103, 177, 0.12) 0%, rgba(0, 151, 215, 0.08) 100%) !important;
    border-left: 5px solid $navy !important;
    animation: slideDown 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 0 8px 24px rgba(58, 103, 177, 0.15) !important;
    border: 2px solid rgba(58, 103, 177, 0.15) !important;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 150px;
      height: 150px;
      background: radial-gradient(circle, rgba(0, 151, 215, 0.1) 0%, transparent 70%);
      pointer-events: none;
    }

    .required-icon {
      color: $navy !important;
      font-size: 24px;
      flex-shrink: 0;
    }

    .required-label {
      font-size: 14px;
      font-weight: 700;
      color: $navy;
      text-transform: uppercase;
      letter-spacing: 0.6px;
    }
  }

  // ============================================
  // SECTION CARD
  // ============================================
  .section-card {
    border-radius: 14px !important;
    border: 2px solid $border-color !important;
    box-shadow: 0 8px 24px rgba(58, 103, 177, 0.1) !important;
    animation: slideInUp 0.8s ease-out;
    background: linear-gradient(to bottom, #ffffff 0%, #fafbff 100%) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      box-shadow: 0 12px 32px rgba(58, 103, 177, 0.15) !important;
      border-color: rgba(58, 103, 177, 0.3) !important;
    }

    .section-title {
      font-size: 18px;
      font-weight: 700;
      color: $primary-color;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 16px 20px !important;
      background: linear-gradient(135deg, rgba(58, 103, 177, 0.05) 0%, rgba(0, 151, 215, 0.05) 100%);
      border-radius: 12px 12px 0 0;
    }
  }

  // ============================================
  // FIELD STYLES
  // ============================================
  .field-label {
    display: block;
    font-size: 13px;
    font-weight: 700;
    color: $primary-color;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;

    .text-danger {
      color: $danger;
      font-weight: 900;
      margin-right: 4px;
    }

    small {
      font-weight: 500;
      font-size: 11px;
      color: $text-90-black;
      text-transform: lowercase;

      &.text-muted {
        color: #999;
      }
    }
  }

  .field-input {
    transition: all 0.3s ease;

    &:focus-within {
      box-shadow: 0 0 0 3px rgba(58, 103, 177, 0.1);
    }
  }

  // ============================================
  // BUTTON SECTION
  // ============================================
  .button-section {
    padding: 16px 24px 24px 24px;
    background: linear-gradient(135deg, rgba(58, 103, 177, 0.03) 0%, rgba(0, 151, 215, 0.03) 100%);
    border-top: 2px solid $border-color;
    margin: 0;

    .action-btn {
      min-width: 160px;
      border-radius: 10px !important;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      font-size: 13px;

      &.close-btn {
        background: linear-gradient(135deg, #a52a2a 0%, #8b2323 100%) !important;

        &:hover:not(:disabled) {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(165, 42, 42, 0.25);
        }
      }

      &.save-btn {
        background: linear-gradient(135deg, $success 0%, #159042 100%) !important;

        &:hover:not(:disabled) {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(29, 185, 84, 0.25);
        }
      }

      &:disabled {
        opacity: 0.6;
        transform: none !important;
      }
    }
  }

  // ============================================
  // GAP UTILITIES
  // ============================================
  .gap-4 {
    gap: 16px;
  }

  .gap-3 {
    gap: 12px;
  }

  // ============================================
  // RESPONSIVE DESIGN
  // ============================================
  @media (max-width: 768px) {
    .header-section {
      margin: 10px !important;
    }

    .form-card {
      margin: 0 10px 20px 10px;
    }

    .header-title {
      font-size: 24px;
    }

    .header-subtitle {
      font-size: 13px;
    }

    .button-section {
      .action-btn {
        width: 100%;
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>